import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	width: 46,
	height: 32,
	viewBox: "0 0 46 32",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M45 3.308v25.384c0 .612-.39 1.2-1.087 1.632-.696.433-1.64.676-2.624.676H9.743c-.984 0-1.928-.243-2.624-.676-.696-.433-1.087-1.02-1.087-1.632V20.35L1 16.5l5.032-3.775V3.308c0-.612.391-1.2 1.087-1.632C7.815 1.243 8.759 1 9.743 1H41.29c.984 0 1.928.243 2.624.676C44.61 2.109 45 2.696 45 3.308Z",
		stroke: "#000",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20width%3D%2246%22%20height%3D%2232%22%20viewBox%3D%220%200%2046%2032%22%3E%3Cpath%20d%3D%22M45%203.308v25.384c0%20.612-.39%201.2-1.087%201.632-.696.433-1.64.676-2.624.676H9.743c-.984%200-1.928-.243-2.624-.676-.696-.433-1.087-1.02-1.087-1.632V20.35L1%2016.5l5.032-3.775V3.308c0-.612.391-1.2%201.087-1.632C7.815%201.243%208.759%201%209.743%201H41.29c.984%200%201.928.243%202.624.676C44.61%202.109%2045%202.696%2045%203.308Z%22%20stroke%3D%22%23000%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
